export default __webpack_public_path__ + "static/media/Alatin-eng.edd84b26.jpg";